<template>
  <div class="CookiesWidget">
    <div id="consent_blackbar"></div>
    <!--
      <div id="teconsent"></div>

    <div class="cookiealert show">
      <div class="container">
        <div>
          <p>
            Este sitio utiliza cookies y otras tecnologías relacionadas tal como se describe en
            nuestras
            <a href="https://www.iff.com/privacy-statement" target="_blank"
              >Políticas de Privacidad</a
            >
            con fines que pueden incluir la eficiente operación del sitio, análisis y mejora de la
            experiencia de usuario o publicidad.
          </p>
        </div>
        <div class="cookiealert-boton">
          <button
            type="button"
            class="btn-al btn-al-lg btn-al-celeste js-scroll-trigger"
            @click="closeCookieWidget()"
          >
            Acepto
          </button>
          <a href="javascript:void(0)" target="_parent" onclick="truste.eu&&truste.eu.clickListener()"
            >Cookie Preferences</a
          >
        </div>
      </div>
    </div>
    -->
  </div>
</template>

<script>
export default {
  name: 'CookiesWidget',
  props: ['logged'],
  methods: {
    closeCookieWidget() {
      this.$parent.closeCookieWidget();
    },
  },
};
</script>

<style lang="scss" src="./CookiesWidget.scss"></style>
